import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import MoneyUnit決算期TableHeader from '@/components/moneyUnit決算期TableHeader/MoneyUnit決算期TableHeader.vue';
import C貸借損益TableRow from '@/components/貸借損益TableRow/貸借損益TableRow.vue';

import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';
import 業績予測Mixin from '@/entries/user/mixins/業績予測Mixin';

import { 決算期TableHeader } from '@/classes/common/決算期Utility';
import { 計画Plbscf } from '@/classes/service/Abstract計画PlbscfService';
import 業績予測Service from '@/classes/service/モニタリング/業績予測Service';

export default mixins(業績予測Mixin, PlbscfKeystrokeResetMixin).extend({
  name: 'M業績予測三表Mixin',

  props: {
    service: {
      type: Object as PropType<業績予測Service>,
      required: true,
    },
    計画Plbscf: {
      type: Object as PropType<計画Plbscf>,
      required: true,
    },
  },

  components: {
    MoneyUnit決算期TableHeader,
    C貸借損益TableRow,
  },

  data(): {
    isCF計算書: boolean;
  } {
    return {
      isCF計算書: false, // CF計算書はtrueにする
    };
  },

  computed: {
    header(): 決算期TableHeader[] {
      return this.service.getHeaderBy基準値(this.vモニタリング業績予測基準値, this.isCF計算書);
    },
  },
});
